import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { useSearchParams } from "react-router-dom";
import { saveAuth } from "../globals/authentication";

export default function LoginInternal() {
  const [searchParams] = useSearchParams();
  const authDetails = searchParams.get("authDetails");
  const [loggedIn, setLoggedIn] = useState(false);
  const [redirectionURL, setRedirectionURL] = useState("/");

  useEffect(() => {
    const authDataObj = JSON.parse(decodeURIComponent(authDetails));
    saveAuth(authDataObj);
    setRedirectionURL(authDataObj?.redirectionURL || "/");
    setLoggedIn(true);
  }, []);

  if (loggedIn) {
    window.location.href = redirectionURL;
  } else {
    return (
      <div>
        <Helmet>
          <title>Logging in... - Farmapp</title>
        </Helmet>
        <h3>Logging in...</h3>
      </div>
    );
  }
}
